import React from 'react';
import './Jobs.css';

function Jobs() {
  return (
    <div className="jobs-page">
      <div className="jobs-coming-soon">
        <div className="jobs-hero">
          <div className="jobs-hero-badge">Coming in V2</div>
          <h1 className="jobs-hero-title">
            The future of
            <br />
            theater casting.
          </h1>
          <p className="jobs-hero-subtitle">
            Jobs, auditions, and talent discovery — all in one place, all connected to your network.
          </p>
        </div>

        <div className="jobs-features">
          <div className="jobs-feature-card feature-casting">
            <div className="jobs-feature-number">01</div>
            <h2>Jobs & Opportunities</h2>
            <p>
              Not just casting — stage management, design, crew, production, and admin roles too.
              Post and find every type of theater job. Opportunities are surfaced based on your
              network, the theaters you've worked at, and the people you know. A job at a company
              where you have connections shows up first.
            </p>
          </div>

          <div className="jobs-feature-card feature-discovery">
            <div className="jobs-feature-number">02</div>
            <h2>Talent Discovery</h2>
            <p>
              Upload your 32-bar cuts right from your Showcase profile — legit, pop/rock,
              contemporary, comedic, ballad. Casting directors pick the style they want, filter by
              vocal type, age range, and location, then swipe through performances. Star the ones
              they love. Connect directly.
            </p>
            <div className="jobs-feature-tags">
              <span>Legit</span>
              <span>Pop/Rock</span>
              <span>Contemporary</span>
              <span>Comedic</span>
              <span>Ballad</span>
            </div>
          </div>

          <div className="jobs-feature-card feature-matching">
            <div className="jobs-feature-number">03</div>
            <h2>Smart Matching</h2>
            <p>
              Your resume, credits, and connections aren't just a profile — they power your
              recommendations. When a role fits, you'll know.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Jobs;
